export const preferences = {
  issueRefundAtStatus: 'issue_refund_at_status',
  instantBankTransferAllowed: 'instant_bank_transfer_allowed',
  originalPaymentMethodAllowed: 'original_payment_method_allowed',
  instantOriginalPaymentMethodAllowed: 'instant_original_payment_method_allowed',
  storeCreditAllowed: 'store_credit_allowed',
  instantStoreCreditAllowed: 'instant_store_credit_allowed',
  storeCreditDuration: 'store_credit_duration',
  storeCreditExtraValue: 'store_credit_extra_value',
  storeCreditExtraValueType: 'store_credit_extra_value_type',
  storeCreditMinEligibleRefundAmount: 'store_credit_min_eligible_refund_amount',
}

export const refundMethodErrorFields = {
  duration: 'duration',
  extraValue: 'extra_value',
  minEligibleRefundAmount: 'min_eligible_refund_amount',
  maxExtraAmount: 'max_extra_amount',
  instantAllowed: 'instant_allowed',
  nonFieldErrors: 'non_field_errors',
}

export const refundMethodFieldsOrder = [
  refundMethodErrorFields.duration,
  refundMethodErrorFields.extraValue,
  refundMethodErrorFields.minEligibleRefundAmount,
  refundMethodErrorFields.maxExtraAmount,
  refundMethodErrorFields.instantAllowed,
  refundMethodErrorFields.nonFieldErrors,
]

export const refundMethodMessageFields = [
  refundMethodErrorFields.instantAllowed,
  refundMethodErrorFields.nonFieldErrors,
]
